var isStorybook = window.location.href.indexOf('https://uiassets') === 0;
var isLocal = window.location.href.indexOf('https://local') === 0;
var storybookDomain = isLocal ? 'https://uiassets.ingrammicro.com/ui-libv2' : '';
export var SVG_LIB_BASE_PATH = "".concat(storybookDomain).concat(isStorybook ? '/ui-libv2' : '', "/xshared/assets/z/svg");
export var FALLBACK_ICON = 'ImageX';